import { render } from "./AdmGradeMng.vue?vue&type=template&id=f4d8df16&scoped=true"
import script from "./AdmGradeMng.vue?vue&type=script&lang=js"
export * from "./AdmGradeMng.vue?vue&type=script&lang=js"

import "./AdmGradeMng.vue?vue&type=style&index=0&id=f4d8df16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d8df16"]])

export default __exports__